import React from 'react';
import './styles/ReferPatient.css'

const ReferPatient = () => {
  return (
    <div>ReferPatient</div>
  )
}

export default ReferPatient